export function hasRight(user = {}, right = '') {
    if (user && user.roles) {
        for (let index in user.roles) {
            if (right === user.roles[index]) {
                return true;
            }
        }
    }

    return false;
}

export function hasRightIn(user = {}, rights = []) {
    if (user && user.roles) {
        for (let index in user.roles) {
            for (let rightIndex in rights) {
                if (rights[rightIndex] === user.roles[index]) {
                    return true;
                }
            }
        }
    }

    return false;
}
